import http from './http';
import moment from 'moment';

import { API_DATE_FORMAT_WITH_TIME_UTC } from 'config/api';

import { createPaginationQuery } from './helpers';

import OrderStatusItem from './models/OrderStatusItem';
import OrderDetails from './models/OrderDetails';
import OrderDetailsProduct from './models/OrderDetailsProduct';
import PartNumberItem from './models/PartNumberItem';
import { toUTCfromMoment } from 'api/helpers';

export class OrdersAPI {
	static ORDER_STATUS_ENDPOINT = 'OrderHistory/GetOrderHistory';
	static ORDER_DETAILS_ENDPOINT = 'OrderHistory/GetOrderDetails';
	static ORDER_PRODUCTS_ENDPOINT = 'OrderHistory/GetItemsDetails';
	static PART_NUMBER_ENDPOINT = 'SearchPartNumber/GetPartNumbers';

	fetchOrderStatus(start, end) {
		const currentHour = moment().format('LT');

		// eslint-disable-next-line prefer-destructuring
		const hours = currentHour.split(':')[0];

		const offset = moment().utcOffset();

		const current_start_date = moment(start, API_DATE_FORMAT_WITH_TIME_UTC).add(
			hours,
			'hour'
		);

		const current_end_date = moment(end, API_DATE_FORMAT_WITH_TIME_UTC).add(
			hours,
			'hour'
		);

		const start_date = toUTCfromMoment(current_start_date, offset);
		const end_date = toUTCfromMoment(current_end_date, offset);

		const query = `&startDate=${start_date}&endDate=${end_date}`;

		return http
			.get(`${OrdersAPI.ORDER_STATUS_ENDPOINT}?${query}`)
			.then(orders => orders.map(order => new OrderStatusItem(order)));
	}

	fetchOrderDetails(orderNumber) {
		const query = `poNumber=${orderNumber}`;

		return http
			.get(`${OrdersAPI.ORDER_DETAILS_ENDPOINT}?${query}`)
			.then(order => new OrderDetails(order));
	}

	fetchOrderProducts(orderNumber, pagination = { size: 10, page: 1 }) {
		let query = `poNumber=${orderNumber}`;
		query += createPaginationQuery(pagination);

		return http
			.get(`${OrdersAPI.ORDER_PRODUCTS_ENDPOINT}?${query}`)
			.then(products =>
				products.map(product => new OrderDetailsProduct(product))
			);
	}

	fetchPartNumber(searchItemNumber, pagination = { size: 10, page: 1 }) {
		//encode special characters
		let query = `searchItemNumber=${encodeURIComponent(searchItemNumber)}`;
		query += createPaginationQuery(pagination);

		return http
			.get(`${OrdersAPI.PART_NUMBER_ENDPOINT}?${query}`)
			.then(orders => new PartNumberItem(orders));
	}
}

export default new OrdersAPI();



// WEBPACK FOOTER //
// ./src/api/orders.js